import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatUnderline(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 16c3.31 0 6-2.69 6-6V4h-2.5v6c0 1.93-1.57 3.5-3.5 3.5S8.5 11.93 8.5 10V4H6v6c0 3.31 2.69 6 6 6Zm-7 2v2h14v-2H5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
